import { render } from "./EditTerminationReason.vue?vue&type=template&id=51fed514"
import script from "./EditTerminationReason.vue?vue&type=script&lang=js"
export * from "./EditTerminationReason.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__